export default __webpack_public_path__ + "static/media/archive_prospects.b6511b04.png";